// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"49522abb","118":"4021bd66","330":"9a2ff1cd","389":"3aa1d587","583":"5ba7f11c","740":"f9f957e3","963":"0e89dc22","971":"3a528be9"}[chunkId] + ".chunk.js";
};